import { TrackService } from './../../../../../service/track.service';
import { Component, EventEmitter, inject, Input, Output, OnInit } from '@angular/core';
import { StreamService } from '../../../../../service/stream.service';

@Component({
  selector: 'app-drop-down',
  standalone: false,
  templateUrl: './drop-down.component.html',
  styleUrl: './drop-down.component.scss'
})
export class DropDownComponent implements OnInit {
  readonly streamService = inject(StreamService)
  // Injections
  trackService = inject(TrackService);

  // Inputs
  @Input() selectname: string = "Continue";
  @Input() roundId: string | undefined;
  @Input() itemList: any[] = [];
  @Input() continueLink: any;

  // Outputs
  @Output() delted = new EventEmitter<void>();

  // Variables
  showMenue: boolean = false;

  async ngOnInit(): Promise<void> {
    // console.log("Dropdown initialized", this.itemList);
    let counter = 0;
    while (this.itemList.length === 0 && counter < 10) {
      await new Promise(resolve => setTimeout(resolve, 100));
      counter++;
    }
  }

  toggleMenue(): void {
    this.showMenue = !this.showMenue;
  }

  async deleteTrack() {
    if (!this.roundId) return;
    let i = await confirm('Do you really want to delete the Stream?');
    if (i === false) return;

    let result = await this.trackService.deleteTrack(this.roundId);
    console.log(result);

    if (result === true) {
      this.trackService.loadUserTrackData();
      this.delted.emit();
    }
  }
}
